import React from 'react';

import { Stack, Tooltip, WarningAmberIcon } from '@gogame/components';

const Warnings = ({ children, warnings, tooltip }) => {
  return (
    <Stack as={'span'} alignItems={'center'} direction={'row'} spacing={1}>
      <Tooltip title={tooltip}>{children}</Tooltip>
      {warnings?.map((message, i) => {
        return (
          <Tooltip key={`message_${i}`} title={message}>
            <WarningAmberIcon sx={{ fontSize: 16 }} color={'warning'} />
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default Warnings;
